import React, { useState, useRef, useEffect } from "react";
import LeadsOrders from "../Ordermanagment/Caterings/LeadsOrders";
import { Link } from "react-router-dom";
import Cateringpackagesorders from "../Ordermanagment/Caterings/Cateringpackagesorders";
import Cateringdeliveryorders from "./Cateringdeliveryorders";
import Cateringsordersscroll from "./Cateringsordersscroll";
import Cateringsreport from "./Cateringsreport";
function Cateringpackageorders() {
    const [activeTab, setActiveTab] = useState("first"); // default tab
    const isMobile = window.innerWidth <= 768;

    const [isPaused, setIsPaused] = useState(false);

    const toggleCard = (index) => {
        setExpandedCard(expandedCard === index ? null : index);
    };
    const [expandedCard, setExpandedCard] = useState(null); // ✅ expand state
    const scrollRef = useRef(null);
    useEffect(() => {
        const scrollContainer = scrollRef.current;
        let scrollInterval;

        if (scrollContainer && !isPaused) {
            scrollInterval = setInterval(() => {
                if (
                    scrollContainer.scrollTop + scrollContainer.clientHeight >=
                    scrollContainer.scrollHeight
                ) {
                    scrollContainer.scrollTop = 0;
                } else {
                    scrollContainer.scrollTop += 1; // scroll speed
                }
            }, 50);
        }

        return () => clearInterval(scrollInterval);
    }, [isPaused]); // pause state control karega


    const getOfferColor = (type) => {
        switch (type) {
            case "buffet":
                return "#ff6f61";
            case "wedding":
                return "#6a5acd";
            case "birthday":
                return "#ffb347";
            case "corporate":
                return "#2e8b57";
            default:
                return "#333";
        }
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-2"> </div>
                <div className="col-lg-7">  <div
                    style={{
                        width: "100%",
                        maxWidth: "100vw",
                        // margin: '150px 230px',
                        // marginTop: "150px",
                        fontFamily: "Arial, sans-serif",
                    }}
                    className="catering-orders-data"
                >
                    <p
                        className="breadcrumb maamaas-home-bredcum or7"
                        style={{
                            position: "fixed",
                            top: isMobile ? "50px" : "50px",
                            left: isMobile ? "5px" : "275px",
                            width: "100%",
                            backgroundColor: "#fff",
                            zIndex: 1000,
                            padding: "40px 0",
                            fontSize: isMobile ? "14px" : "18px",
                            fontWeight: isMobile ? "normal" : "bold",
                            textAlign: "center",
                            margin: 0,
                            height: "60px"
                        }}
                    >
                        <Link
                            to="/Newmainlandingpage"
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Home
                        </Link>
                        <span className="separator"> &gt; </span>
                        <Link
                            to="/cateringlading"
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Catering & Services
                        </Link>
                        <span className="separator"> &gt; </span>
                        <Link

                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Package_Orders
                        </Link>


                    </p>
                    {/* Tabs Header */}
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            gap: "10px",
                            marginBottom: "20px",
                            marginTop: "-20px"
                        }}
                    >
                        <button
                            onClick={() => setActiveTab("first")}
                            style={{
                                padding: "10px 20px",
                                cursor: "pointer",
                                border: "1px solid rgb(177 93 198)",
                                borderRadius: "8px",
                                fontWeight: "bold",
                                backgroundColor: activeTab === "first" ? "rgb(177 93 198)" : "white",
                                color: activeTab === "first" ? "white" : "rgb(177 93 198)",
                                transition: "0.3s",
                            }}
                        >
                            Package
                        </button>

                        <button
                            onClick={() => setActiveTab("second")}
                            style={{
                                padding: "10px 20px",
                                cursor: "pointer",
                                border: "1px solid rgb(177 93 198)",
                                borderRadius: "8px",
                                fontWeight: "bold",
                                backgroundColor: activeTab === "second" ? "rgb(177 93 198)" : "white",
                                color: activeTab === "second" ? "white" : "rgb(177 93 198)",
                                transition: "0.3s",
                            }}
                        >
                            Reports
                        </button>


                    </div>

                    {/* Tabs Content third */}
                    <div

                    >
                        {activeTab === "first" && <Cateringdeliveryorders />}
                        {activeTab === "second" && <Cateringpackagesorders />}

                    </div>


                    <div>

                        <Cateringsordersscroll />

                    </div>
                </div>
                </div>
                <div className="col-lg-3"> </div>
            </div>
        </div>





    );
}

export default Cateringpackageorders;
